// extracted by mini-css-extract-plugin
export default {"publication-form":"PublicationForm_publication-form__F0wbY","radios-wrapper":"PublicationForm_radios-wrapper__llkUe","textarea-wrapper":"PublicationForm_textarea-wrapper__0H6P+"};